import {
  CoreProvider,
  environment,
  GcpSnackBarProvider,
  StoreProvider,
} from '@back-office/core';
import { createStore } from '@back-office/submerchant';
import CssBaseline from '@material-ui/core/CssBaseline';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './app/App';

const store = createStore();

const isMaintenance = environment.maintenanceMode === 'true';

if (isMaintenance) {
  const MaintenancePage = (): JSX.Element => (
    <div style={{ textAlign: 'center', padding: '20px' }}>
      <h1>We will be back soon!</h1>
      <p>The system is currently under maintenance.</p>
    </div>
  );

  ReactDOM.render(<MaintenancePage />, document.getElementById('root'));
} else {
  ReactDOM.render(
    <CoreProvider>
      <StoreProvider value={store}>
        <CssBaseline />
        <Router>
          <GcpSnackBarProvider>
            <App />
          </GcpSnackBarProvider>
        </Router>
      </StoreProvider>
    </CoreProvider>,
    document.getElementById('root')
  );
}
